import { render, staticRenderFns } from "./SDData.vue?vue&type=template&id=87b13efe"
import script from "./SDData.vue?vue&type=script&lang=js"
export * from "./SDData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports